import { forwardRef as f } from "../../external/preact/compat/dist/compat.module.js";
const a = (r) => f(r);
export {
  a as default,
  a as fixedForwardRef
};
